/* eslint-disable max-lines */
import { ReactComponent as Ic_Data_Protection } from 'resources/icons/Ic_Data_Protection.svg';
import { ReactComponent as Ic_Hamburguesa } from 'resources/icons/Ic_Hamburguesa_grey.svg';
import { ReactComponent as Ic_Delete } from 'resources/icons/Ic_Delete.svg';
import { ReactComponent as Ic_Lenguage } from 'resources/icons/Ic_Lenguage.svg';
import { ReactComponent as Ic_Favorites } from 'resources/icons/Ic_Star_Black--filled.svg';
import { ReactComponent as Ic_User } from 'resources/icons/Ic_User_Gen.svg';
import { ReactComponent as Ic_Alerts } from 'resources/icons/Ic_infoC.svg';
import { ReactComponent as Ic_home } from 'resources/icons/Ic_Home.svg';
import { ReactComponent as Ic_work } from 'resources/icons/Ic_Work.svg';
// import { ReactComponent as Ic_Route } from 'resources/icons/Ic_Route_Gray.svg';
import { ReactComponent as Ic_Location_Gray } from 'resources/icons/Ic_location_time.svg';
import { ReactComponent as Ic_News } from 'resources/icons/Ic_News.svg';
import { ReactComponent as Ic_Bus } from 'resources/icons/Ic_Bus.svg';
import { ReactComponent as Ic_Branch_Line } from 'resources/icons/Ic_branch_line.svg';
// import { ReactComponent as Ic_loc_time } from 'resources/icons/Ic_location_time.svg';
import { ReactComponent as Ic_euro } from 'resources/icons/Ic_euro_thin.svg';
import { ReactComponent as Ic_comment } from 'resources/icons/Ic_comment.svg';
import { ReactComponent as Ic_certificate } from 'resources/icons/Ic_certificate.svg';
import { ReactComponent as Ic_Chat } from 'resources/icons/Ic_Chat.svg';


export const EMT_OFFICE_SECTION_ID = 40;
export const POINTS_SALE_2H_SECTIONS_ID = 10;
export const PALMA_OFFICES_SECTIONS = [30, 40];
export const POINTS_SALE_SECTIONS = [
  10, 20,
]; /* [17,18,19,10,21, 22,23,24,26,27, 28,29,30,31, 32, 33] */
export const POI_DEFAULT_BACKGROUND = '#489ACA';

export const generalOrder = {
  Metro: 0,
  Tranvia: 1,
  Bus: 2,
  Interbus: 3,
  Tren: 4,
  Intercambiador: 5,
};
export const generalOrderTransportId = { 3: 0, 10: 1, 1: 2, 2: 3, 7: 4, 90: 5 };
export const keywordsColors = ['#C17CAB', '#22A867', '#489ACA', '#bf877e', '#E35462'];
export const newsCategoryColors = ['#6A99B0', '#9A9823', '#22A867', '#C17CAB', '#BF877E'];
export const eventCategoryColors = [
  '#499ACA',
  '#C17CAB',
  '#22A867',
  '#BF877E',
  '#828FC2',
  '#6A99B0',
  '#9A9823',
  '#22A867',
];

export const NAV_BOTTOM_MENU = [
  { id: 1, icon: Ic_User, title: 'lb_configuracion_menu_gestionar_cuenta', component: 'account' },
  { id: 2, icon: Ic_Lenguage, title: 'lb_configuracion_menu_idioma', component: 'language' },
  { id: 3, icon: Ic_Alerts, title: 'lb_configuracion_menu_avisos', component: 'warnings' },
  { id: 4, icon: Ic_Favorites, title: 'lb_configuracion_menu_favoritos', component: 'favoritos' },
  { id: 5, icon: Ic_Hamburguesa, title: 'lb_configuracion_menu_ayuda', component: 'help' },
];

export const defaultLocation = { lat: 39.620499321968104, lng: 2.9181603940657213 };

export const MAX_ELEMENTS_SEARCH = 4;

export const TYPES_MARKERS = {
  STOP: 'stop',
  ROUTE: 'route',
  POI: 'poi',
  NOMINATIM: 'nominatim',
  DIRECTION: 'direction',
  GROUP: 'group',
};

export const SEARCH_LINESSTOPS_TYPES = {
  both: 0,
  stops: 1,
  lines: 2,
};

export const zoomMinimoAparicionMarkers = 16;
export const zoomMinimoAparicionCodigo = 18;
export const zoomMinimoAparicionStop = 17;
export const zoomAcercarseAMarcador = 18;

export const MAX_ELEMENTS_RECENTS = 5;
export const MAX_ELEMENTS_SALIDAS = 10;

export const DESC_MIUBICACION = 'MIUBICACION';

const hostsLOCAL: Array<string> = ['localhost', '127.0.0.1'];
const hostsDES: Array<string> = ['manteniment.emtpalma.com', '172.16.1.85'];
const hostsPRE: Array<string> = ['manteniment.emtpalma.com', '172.16.1.85'];
const hostsPROD: Array<string> = [
  'nova.emtpalma.cat',
  'emtpalma.com',
  'emtpalma.es',
  'emtpalma.cat',
  'www.emtpalma.com',
  'www.emtpalma.es',
  'www.emtpalma.cat',
  '34.102.159.36',
];

export const enviroments = {
  endPoint: (function endPoint() {
    let endpoint =
      hostsLOCAL.includes(window.location.hostname) && process.env.REACT_APP_CRTM_API_ENDPOINT_PRE;
    endpoint = endpoint
      ? endpoint
      : hostsDES.includes(window.location.hostname) && process.env.REACT_APP_CRTM_API_ENDPOINT_DES;
    endpoint = endpoint
      ? endpoint
      : hostsPRE.includes(window.location.hostname) && process.env.REACT_APP_CRTM_API_ENDPOINT_PRE;
    endpoint = endpoint
      ? endpoint
      : hostsPROD.includes(window.location.hostname) &&
        `https://${window.location.hostname}/maas/api/v1`;
    return endpoint ? endpoint : '';
  })(),
  deviceTypeId: process.env.REACT_APP_deviceTypeId,
  userTypeId: { anonymous: 1, registred: 2 },
  languageId: 1, // 0:CA, 1:ES, 2:EN
};

export const DEFAULT_LANGUAGE = 'es';
//to change prueba

export const LANGUAGE_OPTIONS = [
  { id: 1, txt: 'lb_ca', value: 'ca', selected: false },
  { id: 2, txt: 'lb_es', value: 'es', selected: false },
  { id: 3, txt: 'lb_en', value: 'en', selected: false },
  { id: 4, txt: 'lb_de', value: 'de', selected: false },
];
export const FILTER_ALERTS_OPTIONS = [
  { id: 1, label: 'Todos los avisos', value: 1 },
  { id: 2, label: 'Mis avisos', value: 2 },
  { id: 3, label: 'Avisos generales', value: 3 },
];

export const timeArray = [
  '00:00',
  '00:30',
  '01:00',
  '01:30',
  '02:00',
  '02:30',
  '03:00',
  '03:30',
  '04:00',
  '04:30',
  '05:00',
  '05:30',
  '06:00',
  '06:30',
  '07:00',
  '07:30',
  '08:00',
  '08:30',
  '09:00',
  '09:30',
  '10:00',
  '10:30',
  '11:00',
  '11:30',
  '12:00',
  '12:30',
  '13:00',
  '13:30',
  '14:00',
  '14:30',
  '15:00',
  '15:30',
  '16:00',
  '16:30',
  '17:00',
  '17:30',
  '18:00',
  '18:30',
  '19:00',
  '19:30',
  '20:00',
  '20:30',
  '21:00',
  '21:30',
  '22:00',
  '22:30',
  '23:00',
  '23:30',
];

export const hourArray = [
  '00',
  '01',
  '02',
  '03',
  '04',
  '05',
  '06',
  '07',
  '08',
  '09',
  '10',
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '17',
  '18',
  '19',
  '20',
  '21',
  '22',
  '23',
];

export const minutesArray = [
  '00',
  '01',
  '02',
  '03',
  '04',
  '05',
  '06',
  '07',
  '08',
  '09',
  '10',
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '17',
  '18',
  '19',
  '20',
  '21',
  '22',
  '23',
  '24',
  '25',
  '26',
  '27',
  '28',
  '29',
  '30',
  '31',
  '32',
  '33',
  '34',
  '35',
  '36',
  '37',
  '38',
  '39',
  '40',
  '41',
  '42',
  '43',
  '44',
  '45',
  '46',
  '47',
  '48',
  '49',
  '50',
  '51',
  '52',
  '53',
  '54',
  '55',
  '56',
  '57',
  '58',
  '59',
];

//TO CHANGE
export const settingOptions = [
  [
    { id: 1, icon: Ic_Lenguage, title: 'lb_configuracion_menu_idioma', component: 'language' },
    /* { id: 2, icon: Ic_User, title: 'lb_configuracion_menu_gestionar_cuenta', component: 'account' }, */
    { id: 10, icon: Ic_certificate, title: 'lb_configuracion_menu_cookies', component: 'cookie'}
  ],
  [
    { id: 3, icon: Ic_euro, title: 'lb_tarifas_recarga', component: 'rates', redirect: true },
    { id: 4, icon: Ic_comment, title: 'lb_atencion_cliente', component: 'support', redirect: true },
    { id: 5, icon: Ic_News, title: 'lb_noticias_novedades', component: 'news', redirect: true },
    { id: 11, icon: Ic_Chat, title: 'lb_participation', component: 'participation'},
    { id: 6, icon: Ic_Bus, title: 'lb_emt_palma', component: 'emt', redirect: true },
  ],
  [
    {
      id: 7,
      icon: Ic_Location_Gray,
      title: 'lb_paso_por_parada',
      component: 'explorer',
      redirect: true,
    },
    { id: 8, icon: Ic_Branch_Line, title: 'lb_lineas', component: 'lines', redirect: true },
  ],
];

export const settingOptionsDetail = [
  {
    id: 1,
    icon: Ic_Alerts,
    title: 'lb_configuracion_menu_notificaciones',
    component: 'notificaciones',
  },
  {
    id: 2,
    icon: Ic_Data_Protection,
    title: 'lb_configuracion_menu_terminos_privacidad',
    component: 'terminos&privacidad',
  },
  {
    id: 3,
    icon: Ic_Delete,
    title: 'lb_configuracion_menu_eliminar_datos',
    component: 'eliminarDatos',
  },
];

export const dicFavCategoryIcon = {
  1: Ic_home,
  2: Ic_work,
};

export const RUTAS_GENERALES = {
  main: '/',
  home: '/:language/inici',
  lines: '/lines',
  planner: '/planner',
  favorites: 'favorites',
  settings: 'settings',
  settings_conf: 'settings/configurations',
  news: 'visitPalma',
  eventDetail: '/news/event-detail',
  newDetail: '/news/detail',
  any: '*',
};

export const RUTAS_GENERALES_MUL = {
  main: '/',
  any: '*',
  ca: {
    main: '/',
    home: 'inici',
    lines: 'linies',
    planner: 'planificador',
    favorites: 'favorits',
    settings: 'config',
    settings_conf: 'config/configuracions',
    news: 'noticies',
    newDetail: 'noticies/detail',
    eventDetail: 'noticies/event-detail',
  },
  es: {
    home: 'inicio',
    lines: 'lineas',
    planner: 'planificador',
    favorites: 'favoritos',
    settings: 'config',
    settings_conf: 'config/configuraciones',
    news: 'noticias',
    newDetail: 'noticias/detail',
    eventDetail: 'noticias/event-detail',
  },
};

export const RUTAS_GENERALES_MUL2 = {
  home: {
    ca: 'inici/',
    es: 'inicio/',
    en: 'home/',
    de: 'heim/',
  },
  activateAccount: 'activate-account/',
  recoveryPassword: 'init-recovery-pwd/',
  main: '/',
  any: '*',
  static: 'emt/',
  static2: 'emt-palma?',
  error: '/error',
  paradas: {
    ca: 'parades/',
    es: 'paradas/',
    en: 'stops/',
    de: 'stoppt/',
  },
  lines: {
    ca: 'linies/',
    es: 'lineas/',
    en: 'lines/',
    de: 'linien/',
  },
  planner: {
    ca: 'planificador/',
    es: 'planificador/',
    en: 'planner/',
    de: 'planer/',
  },
  notices: {
    ca: 'avisos/',
    es: 'avisos/',
    en: 'notices/',
    de: 'hinweise/',
  },
  events: {
    ca: 'esdeveniments/',
    es: 'eventos/',
    en: 'events/',
    de: 'ereignis/',
  },
  // CUSTOMER-SUPPORT
  atclient: {
    ca: 'atclient/',
    es: 'atcliente/',
    en: 'customer-service/',
    de: 'kunden-service/',
  },
  atclientComplaintsSuggestions: {
    ca: 'atclient/reclamacions',
    es: 'atcliente/reclamaciones',
    en: 'customer-service/complaints',
    de: 'kunden-service/beschwerden',
  },
  atclientComplaints: {
    ca: 'atclient/reclamacions/form-reclamacions',
    es: 'atcliente/reclamaciones/form-reclamaciones',
    en: 'customer-service/complaints/form-complaints',
    de: 'kunden-service/beschwerden/form-beschwerden',
  },
  atclientInquiry: {
    ca: 'atclient/reclamacions/form-consulta',
    es: 'atcliente/reclamaciones/form-consulta',
    en: 'customer-service/complaints/form-inquiry',
    de: 'kunden-service/beschwerden/form-anfrage',
  },
  atclientContact: {
    ca: 'atclient/contacte',
    es: 'atcliente/contacto',
    en: 'customer-service/contact',
    de: 'kunden-service/kontakt',
  },
  atclientFaq: {
    ca: 'atclient/faq',
    es: 'atcliente/faq',
    en: 'customer-service/faq',
    de: 'kunden-service/faq',
  },
  atclientFaqCategory: {
    ca: 'atclient/faq/categoria',
    es: 'atcliente/faq/categoria',
    en: 'customer-service/faq/category',
    de: 'kunden-service/faq/Kategorie',
  },
  // RATES
  rates: {
    ca: 'tarifes/',
    es: 'tarifas/',
    en: 'fares/',
    de: 'fahrpreise/',
  },
  ratesDetail: {
    ca: 'tarifes/tarifes',
    es: 'tarifas/tarifas',
    en: 'fares/fares',
    de: 'fahrpreise/fahrpreise',
  },
  ratesPointsSale: {
    ca: 'tarifes/punts-venda',
    es: 'tarifas/puntosventa',
    en: 'fares/sales-points',
    de: 'fahrpreise/verkaufsstellen',
  },
  RatesFaq: {
    ca: 'atclient/faq',
    es: 'atcliente/faq',
    en: 'customer-service/faq',
    de: 'kunden-service/faq',
  },
  //EMT
  emt: {
    ca: 'emt/',
    es: 'emt/',
    en: 'emt/',
    de: 'emt/',
  },
  emtNews: {
    ca: 'emt/noticies',
    es: 'emt/noticias',
    en: 'emt/news',
    de: 'emt/nachrichten',
  },
  emtNewDetail: {
    ca: 'emt-notice/',
    es: 'emt-noticia/',
    en: 'emt-news/',
    de: 'emt-nachrichten/',
  },
  // settings
  settings: {
    ca: 'configuracions/',
    es: 'configuracion/',
    en: 'settings/',
    de: 'einstellungen/',
  },
  movilSettings: {
    ca: 'movil-configuracions/',
    es: 'movil-configuracion/',
    en: 'movil-settings/',
    de: 'movil-einstellungen/',
  },
  settingsFavorites: {
    ca: 'favorits',
    es: 'favoritos',
    en: 'favorite',
    de: 'favorit',
  },
  settings_conf: {
    ca: 'configuracions/detall',
    es: 'config/detalle',
    en: 'settings/detail',
    de: 'Einstellungen/details',
  },
  news: {
    ca: 'visitapalma',
    es: 'visitapalma',
    en: 'visitapalma',
    de: 'visitapalma',
  },
  newDetail: {
    ca: 'noticies/detail',
    es: 'noticias/detail',
    en: 'news/detail',
    de: 'nachrichten/details',
  },
  eventDetail: {
    ca: 'emt-esdeveniment/',
    es: 'emt-eventos/',
    en: 'emt-event/',
    de: 'emt-ereignis/',
  },
  privacyPolicy: {
    ca: 'politica-de-privacitat/',
    es: 'politica-de-privacidad/',
    en: 'privacy-and-policy/',
    de: 'Datenschutzrichtlinie/',
  },
  legalNotice: {
    ca: 'avis-legal/',
    es: 'aviso-legal/',
    en: 'legal-notice/',
    de: 'rechtlicher-hinweis/',
  },
  cookiesPolicy: {
    ca: 'politica-de-cookies/',
    es: 'politica-de-cookies/',
    en: 'cookies-policy/',
    de: 'cookie-richtlinie/',
  },
  statistics: {
    ca: 'estadistiques/',
    es: 'estadisticas/',
    en: 'statistics/',
    de: 'statistiken/',
  },
};

export const CategoryColors = {
  1: {
    categoryId: 1,
    background: '#FAB623',
  },
  2: {
    categoryId: 2,
    background: '#3C86E3',
  },
  3: {
    categoryId: 3,
    background: '#3CDBC0',
  },
  4: {
    categoryId: 4,
    background: '#003159',
    light: true,
  },
  5: {
    categoryId: 5,
    background: '#D81E5D',
    light: true,
  },
  6: {
    categoryId: 6,
    background: '#C9264D',
  },
  7: {
    categoryId: 7,
    background: '#34A7E0',
  },
  8: {
    categoryId: 3,
    background: '#3CDBC0',
  },
  9: {
    categoryId: 4,
    background: '#003159',
    light: true,
  },
  10: {
    categoryId: 5,
    background: '#D81E5D',
    light: true,
  },
  11: {
    categoryId: 6,
    background: '#C9264D',
  },
  12: {
    categoryId: 7,
    background: '#34A7E0',
  },
  15: {
    categoryId: 15,
    background: '#6c387f',
    light: true,
  },
  16: {
    categoryId: 16,
    background: '#a36491',
    light: true,
  },
};

export const VisitPalmaCategoryColors = {
  1: {
    categoryId: 1,
    background: '#FEF0D3',
  },
  2: {
    categoryId: 2,
    background: '#F7D1DE',
  },
  3: {
    categoryId: 3,
    background: '#D7EDFA',
  },
  4: {
    categoryId: 4,
    background: '#E9F2D3',
  },
  5: {
    categoryId: 5,
    background: '#FFA9B1',
  },
};

export const EVENTS_CATEGORIES = {
  es: [
    {
      id: 1,
      name: 'Novedades',
      description: '',
      iconUrl: null,
      iconFavoriteUrl: null,
      iconId: 0,
      iconFavoriteId: 0,
      iconMarkId: 0,
      iconMarkFavoriteId: 0,
      iconSelectedId: 0,
      iconSelectedFavoriteId: 0,
      iconFilterId: 0,
      iconFilterSelectedId: 0,
    },
    {
      id: 2,
      name: 'VisitPalma',
      description: '',
      iconUrl: null,
      iconFavoriteUrl: null,
      iconId: 0,
      iconFavoriteId: 0,
      iconMarkId: 0,
      iconMarkFavoriteId: 0,
      iconSelectedId: 0,
      iconSelectedFavoriteId: 0,
      iconFilterId: 0,
      iconFilterSelectedId: 0,
    },
    {
      id: 3,
      name: 'Noticias',
      description: '',
      iconUrl: null,
      iconFavoriteUrl: null,
      iconId: 0,
      iconFavoriteId: 0,
      iconMarkId: 0,
      iconMarkFavoriteId: 0,
      iconSelectedId: 0,
      iconSelectedFavoriteId: 0,
      iconFilterId: 0,
      iconFilterSelectedId: 0,
    },
    {
      id: 4,
      name: 'Consejos',
      description: '',
      iconUrl: null,
      iconFavoriteUrl: null,
      iconId: 0,
      iconFavoriteId: 0,
      iconMarkId: 0,
      iconMarkFavoriteId: 0,
      iconSelectedId: 0,
      iconSelectedFavoriteId: 0,
      iconFilterId: 0,
      iconFilterSelectedId: 0,
    },
    {
      id: 5,
      name: 'Palma Cultura',
      description: '',
      iconUrl: null,
      iconFavoriteUrl: null,
      iconId: 0,
      iconFavoriteId: 0,
      iconMarkId: 0,
      iconMarkFavoriteId: 0,
      iconSelectedId: 0,
      iconSelectedFavoriteId: 0,
      iconFilterId: 0,
      iconFilterSelectedId: 0,
    },
    {
      id: 6,
      name: 'Rutas',
      description: '',
      iconUrl: null,
      iconFavoriteUrl: null,
      iconId: 0,
      iconFavoriteId: 0,
      iconMarkId: 0,
      iconMarkFavoriteId: 0,
      iconSelectedId: 0,
      iconSelectedFavoriteId: 0,
      iconFilterId: 0,
      iconFilterSelectedId: 0,
    },
    {
      id: 7,
      name: 'Servicios',
      description: '',
      iconUrl: null,
      iconFavoriteUrl: null,
      iconId: 0,
      iconFavoriteId: 0,
      iconMarkId: 0,
      iconMarkFavoriteId: 0,
      iconSelectedId: 0,
      iconSelectedFavoriteId: 0,
      iconFilterId: 0,
      iconFilterSelectedId: 0,
    },
  ],
  ca: [
    {
      id: 1,
      name: 'Novetats',
      description: '',
      iconUrl: null,
      iconFavoriteUrl: null,
      iconId: 0,
      iconFavoriteId: 0,
      iconMarkId: 0,
      iconMarkFavoriteId: 0,
      iconSelectedId: 0,
      iconSelectedFavoriteId: 0,
      iconFilterId: 0,
      iconFilterSelectedId: 0,
    },
    {
      id: 2,
      name: 'VisitPalma',
      description: '',
      iconUrl: null,
      iconFavoriteUrl: null,
      iconId: 0,
      iconFavoriteId: 0,
      iconMarkId: 0,
      iconMarkFavoriteId: 0,
      iconSelectedId: 0,
      iconSelectedFavoriteId: 0,
      iconFilterId: 0,
      iconFilterSelectedId: 0,
    },
    {
      id: 3,
      name: 'Notícies',
      description: '',
      iconUrl: null,
      iconFavoriteUrl: null,
      iconId: 0,
      iconFavoriteId: 0,
      iconMarkId: 0,
      iconMarkFavoriteId: 0,
      iconSelectedId: 0,
      iconSelectedFavoriteId: 0,
      iconFilterId: 0,
      iconFilterSelectedId: 0,
    },
    {
      id: 4,
      name: 'Consells',
      description: '',
      iconUrl: null,
      iconFavoriteUrl: null,
      iconId: 0,
      iconFavoriteId: 0,
      iconMarkId: 0,
      iconMarkFavoriteId: 0,
      iconSelectedId: 0,
      iconSelectedFavoriteId: 0,
      iconFilterId: 0,
      iconFilterSelectedId: 0,
    },
    {
      id: 5,
      name: 'Palma Cultura',
      description: '',
      iconUrl: null,
      iconFavoriteUrl: null,
      iconId: 0,
      iconFavoriteId: 0,
      iconMarkId: 0,
      iconMarkFavoriteId: 0,
      iconSelectedId: 0,
      iconSelectedFavoriteId: 0,
      iconFilterId: 0,
      iconFilterSelectedId: 0,
    },
    {
      id: 6,
      name: 'Rutes',
      description: '',
      iconUrl: null,
      iconFavoriteUrl: null,
      iconId: 0,
      iconFavoriteId: 0,
      iconMarkId: 0,
      iconMarkFavoriteId: 0,
      iconSelectedId: 0,
      iconSelectedFavoriteId: 0,
      iconFilterId: 0,
      iconFilterSelectedId: 0,
    },
    {
      id: 7,
      name: 'Serveis',
      description: '',
      iconUrl: null,
      iconFavoriteUrl: null,
      iconId: 0,
      iconFavoriteId: 0,
      iconMarkId: 0,
      iconMarkFavoriteId: 0,
      iconSelectedId: 0,
      iconSelectedFavoriteId: 0,
      iconFilterId: 0,
      iconFilterSelectedId: 0,
    },
  ],
};

export const citizenCardRatesSelector = [
  {
    profile: 'Residente',
    code: 1,
    transfer: {
      description: null,
      scope: null,
    },
    airport: 100,
    port: 100,
    urban: 80,
  },
  {
    profile: 'No residente',
    code: 16,
    transfer: null,
    port: 115,
    urban: 115,
    airport: 500,
  },
  {
    profile: 'Estudiante Universitario',
    code: 19,
    transfer: null,
    port: 4500,
    urban: 450,
    airport: 670,
  },
  {
    profile: 'Carnet verd',
    code: 20,
    transfer: null,
    port: 450,
    urban: 300,
    airport: 450,
  },
  {
    profile: 'Carnet gran A',
    code: 22,
    transfer: null,
    port: 0,
    urban: 0,
    airport: 0,
  },
  {
    profile: 'Carnet gran B',
    code: 22,
    transfer: null,
    port: 300,
    urban: 300,
    airport: 670,
  },
  {
    profile: 'Palma amb tu',
    code: 22,
    transfer: null,
    port: 4500,
    urban: 450,
    airport: 670,
  },
  {
    profile: 'Familia numerosa',
    code: 22,
    transfer: null,
    port: 300,
    urban: 300,
    airport: 670,
  },
  {
    profile: 'Menores entre 5 y 16 años',
    code: 22,
    transfer: null,
    port: 0,
    urban: 0,
    airport: 0,
  },
];
